import React, { useRef, useState, useEffect } from 'react';

const SignaturePad = ({ onSignatureChange }) => {
    const canvasRef = useRef(null);
    const [isDrawing, setIsDrawing] = useState(false);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        // Setup high-res canvas
        const rect = canvas.getBoundingClientRect();
        canvas.width = rect.width * 2;
        canvas.height = rect.height * 2;
        ctx.scale(2, 2);

        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = 3;
        ctx.strokeStyle = '#1c0042';

        // Fill background white
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    }, []);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        let drawing = false;

        const getPos = (e) => {
            const rect = canvas.getBoundingClientRect();
            let clientX, clientY;
            
            if (e.touches && e.touches.length > 0) {
                clientX = e.touches[0].clientX;
                clientY = e.touches[0].clientY;
            } else if (e.changedTouches && e.changedTouches.length > 0) {
                clientX = e.changedTouches[0].clientX;
                clientY = e.changedTouches[0].clientY;
            } else {
                clientX = e.clientX;
                clientY = e.clientY;
            }

            return {
                x: clientX - rect.left,
                y: clientY - rect.top
            };
        };

        const handleStart = (e) => {
            if (e.cancelable) e.preventDefault();
            drawing = true;
            setIsDrawing(true);
            const pos = getPos(e);
            const ctx = canvas.getContext('2d');
            ctx.beginPath();
            ctx.moveTo(pos.x, pos.y);
        };

        const handleMove = (e) => {
            if (!drawing) return;
            if (e.cancelable) e.preventDefault();
            const pos = getPos(e);
            const ctx = canvas.getContext('2d');
            ctx.lineTo(pos.x, pos.y);
            ctx.stroke();
        };

        const handleEnd = (e) => {
            if (!drawing) return;
            if (e.cancelable) e.preventDefault();
            drawing = false;
            setIsDrawing(false);
            onSignatureChange(canvas.toDataURL('image/png'));
        };

        canvas.addEventListener('mousedown', handleStart, { passive: false });
        canvas.addEventListener('mousemove', handleMove, { passive: false });
        canvas.addEventListener('mouseup', handleEnd, { passive: false });
        canvas.addEventListener('mouseleave', handleEnd, { passive: false });

        canvas.addEventListener('touchstart', handleStart, { passive: false });
        canvas.addEventListener('touchmove', handleMove, { passive: false });
        canvas.addEventListener('touchend', handleEnd, { passive: false });
        canvas.addEventListener('touchcancel', handleEnd, { passive: false });

        return () => {
            canvas.removeEventListener('mousedown', handleStart);
            canvas.removeEventListener('mousemove', handleMove);
            canvas.removeEventListener('mouseup', handleEnd);
            canvas.removeEventListener('mouseleave', handleEnd);

            canvas.removeEventListener('touchstart', handleStart);
            canvas.removeEventListener('touchmove', handleMove);
            canvas.removeEventListener('touchend', handleEnd);
            canvas.removeEventListener('touchcancel', handleEnd);
        };
    }, [onSignatureChange]);

    const clearSignature = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        onSignatureChange(null);
    };

    return (
        <div className="flex flex-col items-center gap-2 w-full">
            <div className="relative w-full border-2 border-dashed border-purple-500/30 rounded-2xl overflow-hidden shadow-inner bg-white">
                <canvas
                    ref={canvasRef}
                    className="w-full h-32 touch-none cursor-crosshair"
                />
            </div>
            <button
                type="button"
                onClick={clearSignature}
                className="text-[10px] font-black uppercase tracking-widest text-white transition-all rounded-2xl px-5 py-2 shadow-md hover:scale-105 active:scale-95"
                style={{ background: 'linear-gradient(to right, #f58220, #f7931e, #f9a01b)' }}
            >
                Limpiar Firma
            </button>
        </div>
    );
};

export default SignaturePad;
